export default "__VITE_ASSET__948a0636__"